<template>
  <div>
    <div
      ref="lightbox"
      class="lightbox z-90 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex justify-center items-center"
      tabindex="2"
      v-if="visible"
    >
      <div class="z-100 relative mx-auto my-0 max-h-screen relative">
        <!-- CLOSE -->
        <div
          @click.prevent="close"
          class="cursor-pointer fixed top-0 right-0 text-white p-4 hover:scale-125 transform transition-all duration-200 z-80"
        >
          <i class="fal fa-2x fa-times"></i>
        </div>

        <!-- GO LEFT -->
        <div
          @click="goLeft"
          class="bg-blue-500 md:bg-transparent cursor-pointer fixed top-1/2 left-0 text-white h-16 flex items-center -mt-8 p-4 hover:scale-125 transform transition-all duration-200 z-80"
        >
          <i class="fal fa-2x fa-chevron-left"></i>
        </div>

        <!-- GO RIGHT -->
        <div
          @click="goRight"
          class="bg-blue-500 md:bg-transparent cursor-pointer fixed top-1/2 right-0 text-white h-16 flex items-center -mt-8 p-4 hover:scale-125 transform transition-all duration-200 z-80"
        >
          <i class="fal fa-2x fa-chevron-right"></i>
        </div>

        <!-- IMAGES -->
        <div
          class="fixed top-0 left-0 w-screen h-screen flex items-center justify-center"
          @click="close"
        >
          <div
            class="w-screen h-screen md:max-w-2xl lg:max-w-3xl xl:max-w-5xl"
            v-for="(image, index) in images"
            :key="index"
            :class="{ hidden: index !== currentImage }"
          >
            <img :src="image.url" alt class="object-contain w-full h-full" />
          </div>
          <!-- <div
            v-for="(image, index) in images"
            :key="index"
            class="disable-closing w-screen md:max-w-2xl lg:max-w-3xl xl:max-w-5xl max-h-screen"
            :class="{ hidden: index !== currentImage }"
          >
            <img :src="image.url" alt class="object-contain w-full disable-closing" />
            <div
              class="disable-closing bg-gray-800 text-white p-2 text-sm font-semibold leading-relaxed tracking-wider"
              v-if="image.caption"
            >{{ image.caption }}</div>
          </div>-->
        </div>

        <!-- IMAGES COUNTER -->
        <div
          v-if="images.length > 1"
          class="fixed top-0 left-1/2 w-16 -ml-8 bg-gray-800 text-white py-2 text-center font-bold"
        >{{ currentImage + 1 }} / {{ images.length }}</div>
      </div>
      <div
        class="z-80 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-75"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "lightbox",
  data() {
    return {
      visible: false,
      currentImage: 0,
      images: []
    };
  },
  methods: {
    open(id) {
      let index = 0;
      if (id !== undefined) {
        // Find index by searching for IDs in the images list
        this.images.forEach((image, i) => {
          if (image.id === id) {
            index = i;
          }
        });
      }

      this.currentImage = index;
      this.visible = true;
    },
    close($event) {
      if (
        $event !== undefined &&
        Array.from($event.target.classList).includes("disable-closing")
      ) {
        return;
      }

      this.currentImage = 0;
      this.visible = !this.visible;
    },
    goLeft() {
      if (this.currentImage === 0) {
        this.currentImage = this.images.length - 1;
      } else {
        this.currentImage = this.currentImage - 1;
      }
    },
    goRight() {
      if (this.currentImage === this.images.length - 1) {
        this.currentImage = 0;
      } else {
        this.currentImage = this.currentImage + 1;
      }
    },
    keyPress($event) {
      if ($event.code === "ArrowRight") {
        this.goRight();
      } else if ($event.code === "ArrowLeft") {
        this.goLeft();
      } else if ($event.code === "Escape") {
        this.close();
      }
    }
  },
  destroyed() {
    window.removeEventListener("keypress", this.keyPress);
  },
  watch: {
    visible() {
      if (this.visible) {
        window.addEventListener("keydown", this.keyPress);

        document
          .getElementsByTagName("html")[0]
          .classList.add("overflow-hidden");
        document.getElementsByTagName("html")[0].classList.add("h-screen");
        setTimeout(() => {
          this.$refs.lightbox.classList.add("lightbox-open");
        }, 50);
      } else {
        window.removeEventListener("keypress", this.keyPress);
        document
          .getElementsByTagName("html")[0]
          .classList.remove("overflow-hidden");
        document.getElementsByTagName("html")[0].classList.remove("h-screen");
        this.$refs.lightbox.classList.remove("lightbox-open");
      }
    }
  }
};
</script>
<style>
.lightbox {
  opacity: 0;
  transition: opacity 0.25s ease;
}
.lightbox-open {
  opacity: 1;
}
</style>
